import React, { useContext, useState } from "react";
import "./index.scss";
import ServiceTickets from "../../../../components/service-tickets";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../../core/custom-button";
import { Icon } from "@iconify/react";
import AppContext from "../../../../utils/context";
import { USER_ROLES } from "../../../../utils/constants";
import CustomButtonComponent from "../../../../core/custom-button";
import { HTTP_METHODS, invokeApi } from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
const ServiceTicket = () => {
  const [viewTicket, setViewTicket] = useState(null);
  const { userDetails } = useContext(AppContext);
  const navigate = useNavigate();
  const downloadReports = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.OEM_DOWNLOAD_TICKETS}`,
      null,
      null,
      "blob"
    )
      .then((res) => {
        if (!res.message) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Tickets.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      })
      .catch((err) => console.error(err));
  };
  return (
    <div className="page-body">
      {!viewTicket?.id ? (
        <div className="create-con">
          <div>
            <p className="tab-name">Service Support</p>
            <p className="section-name">View Service Ticket</p>
          </div>
          <div>
            {userDetails.role === USER_ROLES.OEM &&
              userDetails?.admin === true && (
                <CustomButtonComponent
                  variant="contained"
                  color="success"
                  startIcon={
                    <Icon
                      icon="solar:download-bold-duotone"
                      width="1.2rem"
                      height="1.2rem"
                      style={{ color: "white" }}
                    />
                  }
                  sx={{ mr: 2 }}
                  onClick={downloadReports}
                >
                  Download
                </CustomButtonComponent>
              )}
            <CustomButton
              variant="contained"
              onClick={() => navigate("/oem/create-ticket")}
              startIcon={
                <Icon
                  icon="system-uicons:create"
                  width="1.2rem"
                  height="1.2rem"
                  style={{ color: "white" }}
                />
              }
            >
              Create Service Ticket
            </CustomButton>
          </div>
        </div>
      ) : (
        <div className=" view-detailed-ticket">
          <ArrowBackIcon
            sx={{ cursor: "pointer", marginRight: "20px" }}
            onClick={() => {
              setViewTicket(null);
            }}
          />
          <div className="border-r">
            <p className="tab-name">Service Support</p>
            <p className="section-name">View Service Ticket</p>
          </div>
          <div>
            <p className="tab-name">Ticket ID</p>
            <p className="section-name">
              {viewTicket.ticketId || viewTicket.id}
            </p>
          </div>
        </div>
      )}

      <ServiceTickets viewTicket={viewTicket} setViewTicket={setViewTicket} />
    </div>
  );
};

export default ServiceTicket;
